import constructLocalEntity from 'src/utils/vuexModuleConstructor/constructLocalEntity';
import { isCheckbox } from 'src/types/columnFlags';
const controlledActions = {
    create: [-1],
    fetch: [0],
    update: [-1],
    delete: [-1],
    downloadList: [0],
    uploadList: [-1]
};
const columns = (state, getters, rootState, rootGetters) => {
    return [
        { name: 'id', field: 'name', hideWhenDisplaying: true },
        { name: 'name' },
        { name: 'abbrev' },
        { name: 'utc_offset' },
        { name: 'is_dst', isCheckbox }
    ];
};
const localEntity = constructLocalEntity({
    // @ts-ignore
    columns,
    remoteEntityName: 'pg_catalog.pg_timezone_names',
    apiVersion: 1,
    controlledActions,
    pageTitle: 'Time zones dictionary'
});
export default localEntity;
